@if (loaderIcon | async) {
  <app-loader></app-loader>
}
<form [formGroup]="priorityNotesForm" novalidate>
  <div class="modal-header">
    <h5 class="modal-title">Priority Note</h5>
    <button type="button" class="close" aria-label="Close" data-dismiss="modal" (click)="onclickCancel()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-md-5  d-flex align-items-center">
        <label class="me-3 mb-0">Unit #</label>
        <select class="form-control w-auto" formControlName="UnitNumber"
          (change)="getPriority($event)" [style.color]="'red'">
          @for (item of unitList; track item) {
            <option [value]="item.UnitId + '-' + (item.LeaseNumber > 0 ? 'Lease' : item.ReservationNumber > 0 ? 'Reservation' : 'Inquiry')"
              [style.color]="'red'">
            {{item.UnitNumber}}</option>
          }
        </select>
      </div>
    </div>
    <div class="row mt-3 pt-2">
      <div class="col-12">
        <label class="pure-material-checkbox mb-2">
          <input type="checkbox" class="custom-control-input" class="form-control"
            formControlName="PriorityNote">
            <span class="font_weight_500">Priority Note</span>
          </label>
          <div class="ms-3 d-inline-flex label_responsive">
            <span style="width: 155px;" class="span_margin">Keep Active Until</span>
            <ejs-datepicker [readonly]="!priorityNotesForm.value.PriorityNote" class="form-control p-0 h-auto"
              name="date" format='MM/dd/yyyy' floatLabelType='Always' [allowEdit]="false"
              formControlName="keepActiveDate" [min]='today' [allowEdit]="false" style="margin-bottom:10px;">
            </ejs-datepicker>

          </div>
          <textarea rows="5" class="form-control mt-2" formControlName="PriorityNotes"
          [ngClass]="{'highlight-textarea': priorityNotesForm.value.PriorityNote === true}"></textarea>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-primary me-3" data-dismiss="modal"
      (click)="onclickCancel()">Cancel</button>
      <button type="button" class="btn btn-primary" [disabled]="disablePriorityNoteSave()"
      (click)="updatePriorityNotes()">Save</button>
    </div>
  </form>